import { combineReducers } from "redux";
import user from "./index";
const reducer = combineReducers({
  user,
});
export default reducer;